module.exports = __webpack_public_path__ + "img/swap_vert.ab1e9ebc.svg";